import { useEffect } from 'react';
import { isIOS } from 'react-device-detect';

const IOS_URL =
  "https://apps.apple.com/kr/app/hotple-%EC%9D%B8%EC%8A%A4%ED%83%80-%ED%95%AB%ED%94%8C-%EC%A7%80%EB%8F%84-%EB%A7%9B%EC%A7%91-%EC%B9%B4%ED%8E%98-%EC%97%AC%ED%96%89-%EB%8D%B0%EC%9D%B4%ED%8A%B8/id6739356719";
const ANDROID_URL =
  "https://play.google.com/store/apps/details?id=com.hotple.hotple";

export default function StoreRedirect() {
  useEffect(() => {
    const storeUrl = isIOS ? IOS_URL : ANDROID_URL;
    window.location.replace(storeUrl);
  }, []);

  return null;
}